import { render, staticRenderFns } from "./editCompanyUser.vue?vue&type=template&id=6463c419&"
import script from "./editCompanyUser.vue?vue&type=script&lang=js&"
export * from "./editCompanyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6463c419')) {
      api.createRecord('6463c419', component.options)
    } else {
      api.reload('6463c419', component.options)
    }
    module.hot.accept("./editCompanyUser.vue?vue&type=template&id=6463c419&", function () {
      api.rerender('6463c419', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/editCompanyUser.vue"
export default component.exports